import { relation_Status, US_STATES } from "../utils/USStates";
import { married_status } from "../utils/USStates";
import { license_type } from "../utils/USStates";
import { employment_type } from "../utils/USStates";
import { house_type } from "../utils/USStates";
import { cob_house_type } from "../utils/USStates";




export const applicationFields = [
  {
    title: "Start",
    subtitle: "Welcome! Let's Start",
    text: "Please enter your basic information and continue to the next step so we can assist you further.",
    fields: [
      { name: "promo_code", label: "Promo Code (Optional)", type: "text", required: false, colSpan: 6, breakAfter: true },
      { name: "first_name", label: "First Name", type: "text", required: true, colSpan: 6, maxlength:100, helperText:" Please enter your first name as it appears on your driver's license",validationPattern: "^[a-zA-Z\\s]*$", validationMessage: "Last name should contain only letters and spaces"},
      { name: "last_name", label: "Last Name", type: "text", required: true, colSpan: 6  ,maxlength:100, validationPattern: "^[a-zA-Z\\s]*$", validationMessage: "Last name should contain only letters and spaces" },
      { name: "dob", label: "Date of Birth", type: "date", required: true, colSpan: 6, breakAfter: true, validation: "validateDOB" },
      { name: "phone_1", label: "Phone Number", type: "text", required: true, colSpan: 6, formatPattern: "###-###-####", validationPattern: "^\\d{3}-\\d{3}-\\d{4}$", validationMessage: "Phone number should be 10 digits" },
      { name: "email", label: "Email", type: "email", required: true, colSpan: 6 ,maxlength:100},
      { name: "address_1", label: "Street Address", type: "text", required: true, colSpan: 6, maxlength:100, autocomplete: "locationIQ" },
      { name: "address_2", label: "Apt/Unit", type: "text", required: false, colSpan: 3,maxlength:50 },
      { name: "city", label: "City", type: "text", required: true, colSpan: 3,maxlength:50, validationPattern: "^[a-zA-Z\\s]*$", validationMessage: "City should contain only letters and spaces" },
      { name: "state", label: "State", type: "select", required: true, colSpan: 4, options: US_STATES, placeholder: "Choose State" },
      { name: "zip", label: "Zip Code", type: "text", required: true, colSpan: 4,maxlength:5, minlength:5, validationPattern: "^[0-9]{5}$", validationMessage: "Zip code should be 5 digits" },
      // Hidden field to control conditional rendering
      {
        name: "address_since",
        label: "Current Address Since",
        type: "date",
        required: true,
        colSpan: 4,
        validation: "validateIssueDate",
        triggers: "checkAddressDuration",
        conditional: {
          field: "show_past_address",
          values: [true],
          fields: [
            { type: "heading", label: "Previous Address Details", colSpan: 12 },
            { name: "past_address_1", label: "Previous Street Address", type: "text", required: true, colSpan: 9 },
            { name: "past_address_2", label: "Previous Apt/Unit", helperText:" Type N/A if no Unit/Apt", type: "text", required: false, colSpan: 3 },
            { name: "past_city", label: "Previous City", type: "text", required: true, colSpan: 4, validationPattern: "^[a-zA-Z\\s]*$", validationMessage: "City should contain only letters and spaces" },
            { name: "past_state", label: "Previous State", type: "select", options: US_STATES, required: true, colSpan: 4 },
            { name: "past_zip", label: "Previous Zip Code", maxlength:5 ,type: "text", required: true, colSpan: 4, validationPattern: "^[0-9]{5}$", validationMessage: "Zip code should be 5 digits" },
            { name: "past_movein_date", label: "Previous Move-in Date", type: "date", required: true, colSpan: 6,validation: "validateIssueDate" },
            { name: "past_moveout_date", label: "Previous Move-out Date", type: "date", required: true, colSpan: 6,validation: "validateIssueDate" }
          ]
        }
      },   
      { name: "show_past_address", type: "hidden", colSpan: 0 },

    ],
  },
  {
    title: "Personal",
    subtitle: (data) => `Hello! ${data.first_name || 'there'}`   ,
    text: "Let's Talk More About Your Personal Details",
    fields: [
      { name: "marital_status", label: "Marital Status", type: "select", options: married_status , placeholder: "Select Below", required: true, colSpan: 6, breakAfter: true },
      { name: "license_no", label: "Driver’s License Number", type: "text", required: false, colSpan: 6,maxlength:25 },
      { name: "drivers_license_type", label: "Driver's License Type", type: "select", required: true, colSpan: 6, options: license_type },
      { name: "drivers_license_issue_date", label: "License Issue Date", type: "date", required: true, colSpan: 4, validation: "validateIssueDate" },
      { name: "drivers_license_expire_date", label: "License Expiration Date", type: "date", required: true, colSpan: 4, validation: "validateExpiryDate" },
      { name: "license_state", label: "License/ID State", type: "select", required: true, colSpan: 4, options: US_STATES, placeholder:"Choose State" },
      { name: "ssn", label: "Social Security Number", type: "text", required: true, colSpan: 6, formatPattern: "###-##-####", validationPattern: "^\\d{3}-\\d{2}-\\d{4}$", validationMessage: "SSN should be 9 digits" },
      { name: "ssn_confirm", label: "Confirm Social Security Number", type: "text", required: true, colSpan: 6, formatPattern: "###-##-####", validationPattern: "^\\d{3}-\\d{2}-\\d{4}$", validationMessage: "SSN should be 9 digits", customValidation: "verifyCSSN" }
    ],
  },
  {
    title: "Employment",
    subtitle:"Tell Us About Your Work. ",
    fields: [
      {
        name: "employment_status",
        label: "Employment Status",
        type: "select",
        options: employment_type,
        required: true,
        colSpan: 6,
        triggers: "changeEmploymentStatus",
        conditional: 
        // [
          {
          field: "employment_status",
          values: ["full-time", "part-time", "self-employed"],
          fields: [
            { name: "employer", label:(data) => data?.employment_status === "self-employed" ? "Business Name " : "Employer Name ", type: "text",required: true, colSpan: 6, maxlength: 100, validationPattern: "^[a-zA-Z\\s]*$", validationMessage: "Employer name should contain only letters and spaces", breakAfter: true },
            { name: "job_title", label: "Job Title ", type: "text",  colSpan: 6, maxlength: 100, validationPattern: "^[a-zA-Z\\s]*$", required: true, validationMessage: "Job title should contain only letters and spaces" },
      
            { name: "employer_phone_1", label: "Phone ", type: "text",  colSpan: 6, required: true, formatPattern: "###-###-####", validationPattern: "^\\d{3}-\\d{3}-\\d{4}$", validationMessage: "Phone number should be 10 digits" },
            { name: "employer_address_1", label: "Street Address ", type: "text",  colSpan: 6, maxlength: 100, autocomplete: "locationIQ", required: true},
      
            { name: "employer_city", label: "City", type: "text", colSpan: 6, maxlength: 100, required: true },
            { name: "employer_state", label: "State ", type: "select", colSpan: 4, options: US_STATES, placeholder: "Choose State", required: true },
            { name: "employer_zip", label: "Zip Code ", type: "number", colSpan: 4, maxlength: 5, required: true },
      
            {
              name: "employer_since",
              label:(data) => data?.employment_status === "self-employed"? "Owned Since": "Employer Since",
              type: "date",
              required: true,
              colSpan: 4,
              validation: "validateIssueDate",
              triggers: "checkEmployerDuration", // optional
              labelIcon:{icon: "fa fa-info-circle", 
              tooltip: "If you are Self Employed, please enter the date you started your business. If you are employed by a company, please enter the date you started working there."},
              conditional: {
                field: "show_past_employment",
                values: [true],
                fields: [
                  { type: "heading", label: "Previous Employment Information", colSpan: 12 },
                  { name: "past_employer", label: "Previous Employer", type: "text", required: true, colSpan: 6 },
                  { name: "past_occupation", label: "Previous Occupation", type: "text", required: true, colSpan: 6 },
                  { name: "past_hire_date", label: "Previous Hire Date", type: "date", required: true, colSpan: 6 },
                  { name: "past_last_day_of_employment_date", label: "Last Day of Employment", type: "date", required: true, colSpan: 6 }
                ]
              }
            },
             { name: "show_past_employment", type: "hidden", colSpan: 0 }, // Hidden controller
          ],
        },
        // {
        //       field: "employment_status",
        //       values: ["retired"],
        //       fields: [
        //         { name: "social_security_income", label: "Social Security Income/Pension", type: "text", required: true, colSpan: 6, maxlength: 15, format: "currency" },
        //       ]
        // }
      
      // ],
        // conditional:{
        //   field: "employment_status",
        //   values: ["retired"],
        //   fields: [
        //     // { name: "social_security_income", label: "Social Security Income/Pension", type: "text", required: true, colSpan: 6, maxlength: 15, format: "currency" },
        //   ]
        // }
      
      }, 
        
      
      {
        name: "coapplicant",
        label: "Do you have Co-borrower on your Loan?",
        type: "radio",
        options: ["Yes", "No"],
        required: true,
        colSpan: 12,
        triggers: "changeCoApplicantStatus",
        conditional: {
          field: "coapplicant",
          values: ["Yes"],
          fields: [
            // Subheading: Employment Information
           
          
            // Subheading: Personal Information
            // { type: "heading", label: "Personal ", colSpan: 12 },
            { name: "co_borrower_relationship", label: "Relationship", type: "select", options: relation_Status, required: true, colSpan: 6, breakAfter: true },
            { name: "co_borrower_first_name", label: "First Name", type: "text", required: true, colSpan: 6, maxlength: 100, helperText: "Please enter your first name as it appears on your driver's license",validationPattern: "^[a-zA-Z\\s]*$", validationMessage: "Employer name should contain only letters and spaces"  },
            { name: "co_borrower_last_name", label: "Last Name", type: "text", required: true, colSpan: 6, maxlength: 100,validationPattern: "^[a-zA-Z\\s]*$", validationMessage: "Employer name should contain only letters and spaces"  },
            { name: "co_borrower_phone_1", label: "Phone", type: "text", required: true, colSpan: 6, formatPattern: "###-###-####", validationPattern: "^\\d{3}-\\d{3}-\\d{4}$", validationMessage: "Phone number should be 10 digits" },
            { name: "co_borrower_email", label: "Email", type: "email", required: true, colSpan: 6, maxlength: 100 },
            { name: "co_borrower_dob", label: "Date of Birth", type: "date", required: true, colSpan: 6, validation: "validateDOB", breakAfter: true },
            { name: "co_borrower_marital_status", label: "Marital Status", type: "select", options: married_status, placeholder: "Select Below", required: false, colSpan: 6, breakAfter: true },
          
            // Subheading: Driver’s License Information
            { type: "heading", label: "Driver’s License ", colSpan: 12 },
            { name: "co_borrower_drivers_license_type", label: "License Type", type: "select", options: license_type, Placeholder: "Choose Type", required: true, colSpan: 6 },
            { name: "co_borrower_license_no", label: "Driver’s License", type: "text", required: true, colSpan: 6 },
            { name: "co_borrower_license_state", label: "License/ID State", type: "select", options: US_STATES, placeholder: "Select State", required: true, colSpan: 4 },
            { name: "co_borrower_drivers_license_issue_date", label: "License Issue Date", type: "date", required: true, colSpan: 4, validation: "validateIssueDate" },
            { name: "co_borrower_drivers_license_expire_date", label: "License Expiration Date", type: "date", required: true, colSpan: 4, validation: "validateExpiryDate" },
          
            // Subheading: Social Security Number
            // { type: "heading", label: "Social Security Number", colSpan: 12 },
            { name: "co_borrower_ssn", label: "Social Security Number", type: "text", required: true, colSpan: 6, formatPattern: "###-##-####", validationPattern: "^\\d{3}-\\d{2}-\\d{4}$", validationMessage: "SSN should be 9 digits" },
            { name: "co_borrower_ssn_confirm", label: "Confirm Social Security Number", type: "text", required: true, colSpan: 6, formatPattern: "###-##-####", validationPattern: "^\\d{3}-\\d{2}-\\d{4}$", validationMessage: "SSN should be 9 digits" },
          
            { type: "heading", label: "Employment Status", colSpan: 12 },
            {
              name: "co_borrower_employment_status",
              label: "Co-Borrower Employment Status",
              type: "select",
              options: employment_type,
              required: true,
              colSpan: 6,
              triggers: "OnChangeCoBorrowerEmploymentStatus",
              conditional: {
                field: "co_borrower_employment_status",
                values: ["full-time", "part-time","self-employed"],
                fields: [
                  { name: "co_borrower_employer", label: (data) => data?.co_borrower_employment_status === "self-employed" ? "Business Name" : "Employer Name", type: "text", required: true, colSpan: 6, maxlength: 50, breakAfter: true },
                  { name: "co_borrower_job_title", label: "Job Title", type: "text", required: true, colSpan: 6, maxlength: 100 },
                  { name: "co_borrower_employer_phone_1", label: "Employer's Phone Number", type: "text", required: true, colSpan: 6, formatPattern: "###-###-####", validationPattern: "^\\d{3}-\\d{3}-\\d{4}$", validationMessage: "Phone number should be 10 digits" },
                  { name: "co_borrower_employer_address_1", label: "Street Address", type: "text", required: true, colSpan: 6, autocomplete: "locationIQ", maxlength: 100 },
                  { name: "co_borrower_employer_city", label: "City", type: "text", required: true, colSpan: 6, maxlength: 100 },
                  { name: "co_borrower_employer_state", label: "State", type: "select", required: true, colSpan: 4, options: US_STATES, placeholder: "Choose State" },
                  { name: "co_borrower_employer_zip", label: "Zip Code", type: "number", required: true, colSpan: 4, maxlength: 5 },
                  {
                    name: "co_borrower_employer_since",
                    label: (data) => data?.co_borrower_employment_status === "self-employed" ? "Tenure as Business Owner" : "Employer Since",
                    type: "date",
                    required: true,
                    colSpan: 4,
                    validation: "validateIssueDate",
                    triggers: "checkCoBorrowerEmployerDuration",
                    conditional: {
                      field: "co_borrower_show_past_employment",
                      values: [true],
                      fields: [
                        { type: "heading", label: "Co-Borrower Previous Employment", colSpan: 12 },
                        { name: "co_borrower_past_employer", label: "Previous Employer", type: "text", required: true, colSpan: 6 },
                        { name: "co_borrower_past_occupation", label: "Previous Occupation", type: "text", required: true, colSpan: 6 },
                        { name: "co_borrower_past_hire_date", label: "Previous Hire Date", type: "date", required: true, colSpan: 6 },
                        { name: "co_borrower_past_last_day_of_employment_date", label: "Last Day of Employment", type: "date", required: true, colSpan: 6 }
                      ]
                    }
                  },
                  { name: "co_borrower_show_past_employment", type: "hidden", colSpan: 0 }
                ]
              },
              // {
              //   field: "co_borrower_employment_status",
              //   values: ["retired"],
              //   fields: [
              //     { name: "co_borrower_social_security_income", label: "Social Security Income/Pension", type: "text", required: true, colSpan: 6, format: "currency", maxlength: 15 }
              //   ]
              // }
             breakAfter: true
            },
            // Subheading: Address Information
            { type: "heading", label: "Address Details ", colSpan: 12 },
            { name: "co_borrower_address_1", label: "Street Address", type: "text", required: true, colSpan: 6, autocomplete: "locationIQ", maxlength: 100 },
            { name: "co_borrower_address_2", label: "Apt/Unit", type: "text", required: false, colSpan: 3, maxlength: 100, validationMessage: "N/A if no Apt/Unit." },
            { name: "co_borrower_city", label: "City", type: "text", required: true, colSpan: 3, maxlength: 100 },
            { name: "co_borrower_state", label: "State", type: "select", required: true, colSpan: 4, options: US_STATES, placeholder: "Choose State" },
            { name: "co_borrower_zip", label: "Zip Code", type: "number", required: true, colSpan: 4, maxlength: 5 },
            {
              name: "co_borrower_address_since",
              label: "Living Since",
              type: "date",
              required: true,
              colSpan: 4,
              triggers: "checkCoBorrowerAddressDuration",
              conditional: {
                field: "co_borrower_show_past_address",
                values: [true],
                fields: [
                  { type: "heading", label: "Co-Borrower Previous Address", colSpan: 12 },
                  { name: "co_borrower_past_address_1", label: "Previous Street Address", type: "text", required: true, colSpan: 6 },
                  { name: "co_borrower_past_address_2", label: "Previous Apt/Unit", type: "text", colSpan: 6 },
                  { name: "co_borrower_past_city", label: "City", type: "text", required: true, colSpan: 4 },
                  { name: "co_borrower_past_state", label: "State", type: "select", options: US_STATES, required: true, colSpan: 4 },
                  { name: "co_borrower_past_zip", label: "Zip Code", type: "text", required: true, colSpan: 4 },
                  { name: "co_borrower_past_movein_date", label: "Move-in Date", type: "date", required: true, colSpan: 6 },
                  { name: "co_borrower_past_moveout_date", label: "Move-out Date", type: "date", required: true, colSpan: 6 }
                ]
              }
            },
            { name: "co_borrower_show_past_address", type: "hidden", colSpan: 0 },
            // Subheading: Housing Information
            { type: "heading", label: "Income Details", colSpan: 12 },
            { name: "co_borrower_rent_own", label: "Do you rent or own your home?", type: "select", options: cob_house_type, required: true, colSpan: 6, triggers: "toggleMonthlyPayment" },
            { name: "co_borrower_monthly_home_payment", label: "Monthly Rent/Mortgage Payment", type: "text", required: true, colSpan: 6, format: "currency", maxlength: 15 },
            { name: "co_borrower_gross_income", label: "Monthly Gross Income", type: "text", required: true, colSpan: 6, format: "currency", maxlength: 15 },
          ]
        }
      }
    ]
  },
  


  {
    title: "Finances",
    subtitle: "Let's Talk About Your Finances",
    fields: [
      { name: "monthly_income", label:  (data) => data?.employment_status === "retired" ? "Social Security Income" : "Monthly Income", type: "text", required: true, colSpan: 6, format: "currency" ,maxlength:15, labelIcon:{icon: "fa fa-info-circle", 
              tooltip: "If not monthly income, please enter your pension, disbaled income, or any other income you receive monthly."},
              },
      { name: "rent_own", label: "Rent or Own", type: "select", options: house_type, required: true, colSpan: 6, triggers: "toggleMonthlyPayment",maxlength:15 },
      {
        conditional: { field: "rent_own", values: ["Rent"] },
        fields: [
          { name: "monthly_home_payment", label: "Monthly Rent/Mortgage Payment", type: "text", required: true, colSpan: 6, format: "currency",maxlength:15 }
        ]
      },
      { name: "other_expenses", label: "Other Expenses", type: "text", required: false, colSpan: 6, format: "currency" ,maxlength:15}
    ],
  },
  {
    title: "Vehicle",
    subtitle:"Tell Us About Your Vehicle",
    fields: [
      { name: "vin", label: "VIN Number", type: "text", required: true, colSpan: 6, validationPattern: "^[a-zA-Z0-9]{17}$", validationMessage: "VIN number should be 17 characters", triggers: "onVinInputChange" ,maxlength:17, labelIcon:{icon: "fa fa-info-circle", tooltip: "Vehicle Identification Number (VIN) is a unique code used by the automotive industry to identify individual motor vehicles. You can find your VIN on the dashboard near the windshield."}},
      { name: "make", label: "Make", type: "text", required: true, colSpan: 6, readonly: true ,maxlength:100},
      { name: "model", label: "Model", type: "text", required: true, colSpan: 4, readonly: true ,maxlength:100},
      { name: "model_year", label: "Year", type: "number", required: true, colSpan: 4, readonly: true,maxlength:4 },
      { name: "mileage", label: "Mileage", type: "number", required: true, colSpan: 4,maxlength:15, validationPattern: "^[0-9]+$", validationMessage: "Mileage should be a number. No commas." },
      {
        subtitle: "Tell Us About Your Loan",
        fields: [
          { name: "current_monthly_payment", label: "Monthly Loan Payment", type: "text", required: true, colSpan: 6, format: "currency" ,maxlength:15},
          { name: "current_payoff", label: "Remaining Balance", type: "text", required: true, colSpan: 6, format: "currency",maxlength:15 },
          { name: "next_payment_date", label: "Next Payment Date", type: "date", required: true, colSpan: 6 },
          { name: "lien_holder", label: "Current Lender", type: "text", required: true, colSpan: 6,maxlength:100 }
        ]
      },
    {name: "comments", label: "Is there any additional information you think we may need to help finance your loan?", type: "textarea", required: false, colSpan: 12, maxlength:500},
    { name: "credit_check_consent", type:"hidden"}
    ],
  },

  
];
